import { motion } from "framer-motion";
import { Eyebrow, Reveal } from "./Reveal";
import { STEPS } from "./content";

const INCLUDED = [
  "A one-on-one discount review for your new driver",
  "Help enrolling in a telematics safe-driving program",
  "Driver ed certificate and report card submission handled for you",
  "A savings check-in at every renewal as your teen grows",
];

export const Program = () => (
  <section id="program" className="relative overflow-hidden bg-bone text-asphalt" data-testid="program-section">
    <div className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 lg:py-32">
      <div className="grid gap-14 lg:grid-cols-12">
        <Reveal className="lg:col-span-7">
          <p className="flex items-center gap-3 font-mono text-xs font-bold uppercase tracking-[0.28em] text-asphalt">
            <span className="h-2.5 w-2.5 animate-pulse rounded-full bg-[#D97706]" /> Now enrolling in Georgia
          </p>
          <h2 className="mt-6 font-display text-5xl font-black uppercase leading-[0.9] sm:text-7xl lg:text-8xl" data-testid="program-title">
            Introducing the ShieldTeen Safe Driver Program.
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-5 lg:pt-24">
          <p className="font-body text-base leading-relaxed text-asphalt/80 sm:text-lg">
            A guided path from learner's permit to confident driver, built by Hunt Shield Insurance for Georgia families. Here is what's included:
          </p>
          <ul className="mt-8 space-y-4">
            {INCLUDED.map((t, i) => (
              <li key={t} className="flex gap-4 border-b border-asphalt/15 pb-4 font-body font-semibold" data-testid={`program-included-${i}`}>
                <span className="font-mono text-sm text-[#B45309]">+</span> {t}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
      <div className="relative mt-20 grid gap-5 md:grid-cols-2 lg:grid-cols-4">
        <div className="absolute left-0 right-0 top-[38px] hidden h-px border-t-2 border-dashed border-asphalt/25 lg:block" />
        {STEPS.map((s, i) => (
          <motion.div
            key={s.k}
            initial={{ opacity: 0.2, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: i * 0.1 }}
            className="relative rounded-[1.75rem] bg-asphalt p-7 text-bone"
            data-testid={`program-step-${i}`}
          >
            <div className="flex items-center justify-between">
              <span className="rounded-full bg-lane px-3 py-1 font-mono text-[11px] font-bold uppercase tracking-widest text-asphalt">{s.k}</span>
              <span className="font-mono text-xs text-mist">Step 0{i + 1}</span>
            </div>
            <h3 className="mt-8 font-display text-3xl font-black uppercase leading-none">{s.t}</h3>
            <p className="mt-4 font-body text-sm leading-relaxed text-mist">{s.d}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
